import { QueryClient } from "@tanstack/react-query"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: Number.POSITIVE_INFINITY,
      staleTime: 5000, // 5 seconds
      refetchOnWindowFocus: true,
      refetchInterval: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchIntervalInBackground: false,
      suspense: false,
      useErrorBoundary: false,
    },
    mutations: {
      useErrorBoundary: false,
    },
  },
})
